import { makeIcon } from "components/ui/Icon";

export const GreaterThanOrEqualOperatorIcon = makeIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <rect fill="var(--foreground)" height="24" rx="4" width="24" />
    <path d="M8.50743 3L17 10L8.50743 17L7 15.8L13.9851 10L7 4.2L8.50743 3Z" fill="var(--background)" />
    <path d="M7 20V18H17V20H7Z" fill="var(--background)" />
  </svg>,
);
